module.exports = __webpack_public_path__ + "static/media/balance-scale-right.c2d3e629.svg";